//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Area page: diet | sex-drive | stress | energy | sleep
     */
    area: {
      type: String,
      required: true
    }
  }
}
